import { useAddToCartFetchers } from '@jane/bloom/hooks/useAddToCartConfig';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { productCountInCart } from '@jane/bloom/utils/cart/productCountInCart';

/**
 * @returns the total size of the bag, or the number of products matching the productId
 */
export const useOptimisticBagSize = (productId?: number): number => {
  const cartItemCount = useActualBagSize(productId);
  const addToCartFetchers = useAddToCartFetchers(productId);

  return addToCartFetchers
    .filter(({ data, state }) => state === 'loading' && data?.success)
    .map(({ formData }) => Number(formData?.get('count') ?? 1))
    .reduce((prev, acc) => prev + acc, cartItemCount);
};

export const useActualBagSize = (productId?: number): number => {
  const { cart, pinnedStore } = useRootLoaderData();
  return productCountInCart({
    cart,
    currentStoreId: pinnedStore?.id,
    productId,
  });
};
